import ReactGA from 'react-ga4';
import getConfig from 'next/config';

const { publicRuntimeConfig } = getConfig();

export const initGA = () => {
  ReactGA.initialize(publicRuntimeConfig.gaMeasurementId); // Replace with your Measurement ID
};
